import {useEffect, useState} from 'react'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {
  CopilotChatOrg,
  CopilotChatPayload,
  CopilotChatReference,
} from '@github-ui/copilot-chat/utils/copilot-chat-types'

export interface ChatPayload extends CopilotChatPayload {
  findFileWorkerPath: string
  refs?: CopilotChatReference[]
  ssoOrganizations?: CopilotChatOrg[]
}

export function useCopilotChatPayload() {
  const [copilotChatPayload, setCopilotChatPayload] = useState<ChatPayload | null>(null)

  useEffect(() => {
    async function getChatProvider(): Promise<void> {
      if (copilotChatPayload) {
        return
      }

      try {
        const resp = await verifiedFetchJSON('/github-copilot/chat')
        if (!resp.ok) {
          throw new Error(`Failed to fetch chat provider: ${resp.statusText}`)
        }
        const json = (await resp.json()) as ChatPayload
        setCopilotChatPayload(json)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching Copilot Chat provider:', error)
      }
    }
    getChatProvider()
  }, [copilotChatPayload])

  return copilotChatPayload
}
